import { Injectable } from '@angular/core';
import { PaymentMethodName } from '../../enums/payment/payment-method-name';
import { PaymentData } from '../../interfaces/payment/payment-data';
import { DialogTableDataRow } from '../../interfaces/dialog-table-data-row';

@Injectable({
  providedIn: 'root'
})
export class BankAccountToTableDataMapper {

  constructor() { }

  public map(paymentMethodData: PaymentData): DialogTableDataRow[] {
    switch (paymentMethodData.paymentMethod) {
      case PaymentMethodName.PAYPAL:
        return [
          {
            titleStyleClass: 'font-bold',
            i18nTitleKey: 'PAYPALEMAIL',
            value: paymentMethodData.payPalEmailAddress,
          },
        ]
      default:
        return [
          {
            titleStyleClass: 'font-bold',
            i18nTitleKey: 'ACCOUNTHOLDER',
            value: paymentMethodData.accountHolder,
          },
          {
            titleStyleClass: 'font-bold',
            title: 'IBAN',
            value: paymentMethodData.IBAN,
          },
          {
            titleStyleClass: 'font-bold',
            title: 'BIC',
            value: paymentMethodData.BIC,
          },
          {
            titleStyleClass: 'font-bold',
            i18nTitleKey: 'BANK',
            value: paymentMethodData.bank,
          }
        ]
    }
  }
}
